function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { GenerateServiceDescriptionResponseType } from "../../../../hooks/reactQuery/mutations/useGenerateServiceDescription.types";
import { DESCRIPTION_PROMPT } from "./SuggestedDescriptionDisplay/SuggestedDescriptionDisplay.utils";
const canUndo = response => {
  var _response$canUndo;
  return (response === null || response === void 0 ? void 0 : response.type) === GenerateServiceDescriptionResponseType.Message ? (_response$canUndo = response.canUndo) !== null && _response$canUndo !== void 0 ? _response$canUndo : false : false;
};
const isClarification = response => {
  return (response === null || response === void 0 ? void 0 : response.type) === GenerateServiceDescriptionResponseType.Clarification;
};
const conversationId = response => {
  var _response$conversatio;
  return (_response$conversatio = response === null || response === void 0 ? void 0 : response.conversationId) !== null && _response$conversatio !== void 0 ? _response$conversatio : '';
};
const description = response => {
  if (!response) return null;
  switch (response.type) {
    case GenerateServiceDescriptionResponseType.Clarification:
      return response.message;
    case GenerateServiceDescriptionResponseType.Start:
    case GenerateServiceDescriptionResponseType.Message:
      return response.description;
  }
};
const isEmptyResponseData = response => response.isClarification && !response.conversationId || response.conversationId === '' || response.description === DESCRIPTION_PROMPT;
export const emptyResponseData = {
  isEmpty: true,
  canUndo: false,
  isClarification: false,
  conversationId: '',
  description: null
};
export const getResponseData = response => {
  const data = {
    canUndo: canUndo(response),
    isClarification: isClarification(response),
    conversationId: conversationId(response),
    description: description(response)
  };
  return _objectSpread(_objectSpread({}, data), {}, {
    isEmpty: isEmptyResponseData(data)
  });
};